export default "__VITE_ASSET__BPGXLXTg__"